import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { SearchService } from "../../../services/search.service";
import { StorageService } from "../../../services/storage.service";
import { TenantSettingsRepository } from "../../../domain/tenant-settings-repository";
import { UserService } from "../../../domain/user-service";

const TAG = "LibraryWrapper:";

const URL_GRAPHICS = "graphics";
const VIEW_TYPE_STORAGE_KEY = "mam.viewtype";

@Component({
  selector: "library-wrapper-component",
  templateUrl: "./libraryWrapper.component.html",
  styleUrls: ["./libraryWrapper.component.scss"],
  providers: [StorageService],
})
export class LibraryWrapperComponent implements OnInit {
  @Input()
  library;

  @Input()
  libraryType;

  @Input()
  showItemMenuButtons = true;

  @Output()
  onScrollChanged: EventEmitter<any> = new EventEmitter<any>();

  viewType = "list";

  isQCAllowed = false;

  constructor(
    private searchService: SearchService,
    private storageService: StorageService,
    private tenantSettingsRepository: TenantSettingsRepository,
    private userService: UserService,
  ) {
    this.tenantSettingsRepository.getTenantSettings().then((tenantSettings) => {
      const currentUser = this.userService.getCurrentUser();
      this.isQCAllowed =
        tenantSettings.DoQcAnalizeWhenUploading &&
        currentUser.hasQcApprovalPermission;
    });
  }

  ngOnInit() {
    const savedViewType = this.storageService.getItem(VIEW_TYPE_STORAGE_KEY);
    if (savedViewType != null) {
      this.viewType = savedViewType;
    }
  }

  /**
   * change view type property
   * @return void
   */
  viewTypeToggle() {
    this.viewType = this.viewType == "gallery" ? "list" : "gallery";
    this.storageService.setItem(VIEW_TYPE_STORAGE_KEY, this.viewType);
  }

  onScroll() {
    this.onScrollChanged.emit();
  }
}
